import { call, put } from 'redux-saga/effects';
import uniqid from 'uniqid';
import authorizationSuccess from '../actions/authorizationSuccess';
import authorizationFailed from '../actions/authorizationFailed';
import AuthorizationApi from '../api/AuthorizationApi';
import { defineJwt } from '../api/config';
import addNotification from '../actions/addNotification';
import removeNotification from '../actions/removeNotification';
import { DEFAULT_NOTIFICATION_TIMEOUT } from '../hooks/useNotification';

export default function* authorizeSaga(action) {
    try {
        const response = yield call(AuthorizationApi.Authorize, action.payload);
        defineJwt(response.data.jwt);
        yield put(authorizationSuccess(response.data.jwt));
    } catch (error) {
        const notification = {
            id: uniqid(),
            message: error.response.data.details,
            type: 'error',
        };

        yield put(authorizationFailed(error));
        yield put(addNotification(notification));

        const delay = (ms) => new Promise((res) => setTimeout(res, ms));

        yield delay(DEFAULT_NOTIFICATION_TIMEOUT);

        yield put(removeNotification(notification));
    }
}
